import {
  RefSegment,
  refSegmentLabel,
  splitReferenceSegments,
} from '../../../util/references/referenceTokens';

interface Props {
  text: unknown;
  idLabelMap: Record<string, string>;
  isDark?: boolean;
}

// Read-only render of a field's text where each {{<id>.field}} (or legacy
// {{label.field}}) becomes a friendly pill showing the referenced node's CURRENT
// label. Used as the blurred-state backdrop so prompts stay readable while the
// underlying stored token is the stable id.
const ReferenceText = ({ text, idLabelMap, isDark }: Props) => {
  const segments = splitReferenceSegments(text);
  return (
    <>
      {segments.map((seg: RefSegment, i: number) =>
        seg.type === 'ref' ? (
          <span
            key={i}
            title={seg.raw}
            style={{
              display: 'inline-block',
              padding: '0 6px',
              margin: '0 1px',
              borderRadius: '4px',
              fontWeight: 500,
              lineHeight: '18px',
              backgroundColor: isDark ? '#344054' : '#EFF4FF',
              color: isDark ? '#D0D5DD' : '#3538CD',
              whiteSpace: 'nowrap',
            }}
          >
            {refSegmentLabel(seg, idLabelMap)}
          </span>
        ) : (
          <span key={i} style={{ whiteSpace: 'pre-wrap' }}>
            {seg.raw}
          </span>
        ),
      )}
    </>
  );
};

export default ReferenceText;
